import { sleep } from "@captions-web/utils/sleep";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { ClipSequenceSelector } from "~/modules/project/components/clip-sequence-selector/clip-sequence-selector";
import { VideoDetailsClipItemType } from "~/modules/project/network/schemas";
import { css } from "~/styled-system/css";

export const Route = createFileRoute("/storybook/clip-sequence-selector")({
  component: RouteComponent,
});

const exampleClips: VideoDetailsClipItemType[] = [
  {
    index: 0,
    startMs: 0,
    endMs: 5000,
    transcriptText: "have you ever had a dreams",
    selectedClipId: "cv_0",
    variants: [
      {
        clipId: "cv_0",
        state: "COMPLETE",
        thumbnailUrl:
          "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
        videoUrl: "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_0.mp4",
      },
    ],
  },
  {
    index: 1,
    startMs: 5000,
    endMs: 10000,
    selectedClipId: "cv_1",
    transcriptText: "have you ever had a dreams",
    variants: [
      {
        clipId: "cv_1",
        state: "COMPLETE",
        thumbnailUrl:
          "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
        videoUrl: "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_1.mp4",
      },
    ],
  },
  {
    index: 2,
    startMs: 10000,
    endMs: 15000,
    transcriptText: "have you ever had a dreams",
    selectedClipId: "cv_2",
    variants: [
      {
        clipId: "cv_2",
        state: "COMPLETE",
        thumbnailUrl:
          "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
        videoUrl: "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_2.mp4",
      },
    ],
  },
  {
    index: 3,
    startMs: 15000,
    endMs: 20000,
    transcriptText: "have you ever had a dreams",
    selectedClipId: "cv_3",
    variants: [
      {
        clipId: "cv_3",
        state: "COMPLETE",
        thumbnailUrl:
          "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
        videoUrl: "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_3.mp4",
      },
    ],
  },
  {
    index: 4,
    startMs: 20000,
    endMs: 25000,
    transcriptText: "have you ever had a dreams",
    selectedClipId: "cv_4",
    variants: [
      {
        clipId: "cv_4",
        state: "COMPLETE",
        thumbnailUrl:
          "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
        videoUrl: "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_4.mp4",
      },
    ],
  },
];

function RouteComponent() {
  const [clips, setClips] = useState(exampleClips);

  const handleRegenerate = async (index: number) => {
    const nextClips = [...clips];
    nextClips[index] = {
      ...nextClips[index],
      variants: [
        ...nextClips[index].variants,
        {
          clipId: `cv_${index}_new`,
          state: "PROCESSING",
        },
      ],
    };
    setClips(nextClips);
    await sleep(3000);

    const nextNextClips = [...nextClips];
    nextNextClips[index] = {
      ...nextNextClips[index],
      variants: nextNextClips[index].variants.map((variant) =>
        variant.clipId === `cv_${index}_new`
          ? {
              ...variant,
              state: "COMPLETE",
              thumbnailUrl:
                "https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/Screenshot%202025-05-19%20at%2011.32.05%E2%80%AFPM.png",
              videoUrl: `https://pub-d3bb7c366a0748e3b9197801deb73ea1.r2.dev/segment_${index}.mp4`,
            }
          : variant
      ),
    };
    setClips(nextNextClips);
  };

  const handleSelect = (index: number, clipId: string) => {
    const nextClips = [...clips];
    nextClips[index] = {
      ...nextClips[index],
      selectedClipId: clipId,
    };
    setClips(nextClips);
  };

  return (
    <div className={clipSequenceContainerStyles}>
      <ClipSequenceSelector
        clips={clips}
        onRegenerate={handleRegenerate}
        onSelect={handleSelect}
        videoId={"testi-video-id"}
        projectId={"test-project-id"}
      />
    </div>
  );
}

const clipSequenceContainerStyles = css({
  backgroundColor: "$gray.950",
  display: "flex",
  flex: 1,
  height: "calc(100dvh - 80px)",
  maxHeight: "calc(100dvh - 80px)",
  padding: "10px",
});
